import _ from "lodash";
import React from "react";
import Style from "style-it";
import { v1 } from "uuid";
/**
 * https://fontawesome.com/search?s=solid%2Cbrands
 * or 
 * https://react-icons.github.io/react-icons/search
 * or
 * https://mui.com/material-ui/material-icons/
 */
class FontAwesomeX {

  /**
   * @typedef {{
   *    type: "beat" | "fade" | "beat-fade" | "bounce" | "flip" | "shake" | "spin" | "spin-reverse" | "spin-pulse",
   *    beatScale?: Number,
   *    fadeOpacity?: Number,
   *    duration?: Number,
   *    beatFadeScale?: Number,
   *    beatFadeOpacity?: Number,
   *    bounceRebound?: Number,
   *    bounceHeight?: Number,
   *    bounceStartScaleX?: Number,
   *    bounceStartScaleY?: Number,
   *    bounceJumpScaleX?: Number,
   *    bounceJumpScaleY?: Number,
   *    bounceLandScaleX?: Number,
   *    bounceLandScaleY?: Number,
   *    flipX?: Number,
   *    flipY?: Number,
   *    flipZ?: Number,
   *    flipAngle?: Number,
   *    delay?: Number,
   *    direction?: "normal" | "reverse" | "alternate" | "alternate-reverse",
   *    duration?: Number,
   *    iterationCount?: Number,
   *    timingFunction?: "linear" | "ease-in-out" | String,
   *  }} faanimateoption
   * 
   * @typedef {{
   *  color?: String,
   *  size?: "2xs" | "xs" | "sm" | "lg" | "xl" | "2xl" | Number,
   *  fixWidth?: Boolean,
   *  rotate?: "90" | "180" | "270",
   *  flip?: "horizontal" | "vertical" | "both",
   *  customRotate?: Number,
   *  animate?: faanimateoption,
   *  stack?: Number,
   *  border?: Boolean
   *  borderOption?: {
   *    color?: String,
   *    padding?: String,
   *    radius?: String,
   *    style?: "none" | "hidden" | "dotted" | "dashed" | "solid" | "double" | "groove" | "ridge" | "inset" | "outset" | String,
   *    width?: String,
   *  },
   *  pullLeft?: Boolean,
   *  pullRight?: Boolean,
   *  pullOption?: {
   *    margin?: String
   *  }
   * }} faoption
   */

  /**
   * 
   * @param {String} fullname 
   * @param {*} innerStyle
   * @returns 
   */
  static GetDirect(fullname, innerStyle){
    return(
      <i className={fullname} style={innerStyle}/>
    );
  }

  /**
   * 
   * @param {"solid" | "regular" | "light" | "thin" | "duotone" | "brands"} theme 
   * @param {String} name 
   * @param {faoption} option 
   */
  static Get(theme, name, option = {}){
    let iconClass = this.GetIcon(theme, name);
    let {nameStack, innerStyle} = this.GetStackedClassNames(option);
    let className = _.join([...nameStack, ...iconClass], " ");
    let style = _.join(innerStyle, " ");
    let genClass = "izo-" + v1();
    return (
      <Style>
        {"." + genClass + "{" + style + "}"}
        <i className={className + " " + genClass}/>
      </Style>
    );
  }

  /**
   * 
   * @param {JSX.Element} component 
   * @param {faoption} option 
   */
  static Animate(option = {}){

    let {nameStack, innerStyle} = this.GetStackedClassNames(option);
    let genClass = "izo-" + v1();
    nameStack.push(genClass);

    let style = _.join(innerStyle, " ");
    
    let className = _.join(nameStack, " ");
    let styleString = "." + genClass + "{" + style + "}";

    return {className, styleString};
  }

  /**
   * 
   *  @param {"solid" | "regular" | "light" | "thin" | "duotone" | "brands"} theme 
   * @param {String} name 
   * @returns 
   */
  static GetIcon(theme, name){
    let nameStack = [];

    nameStack.push("fa-" + theme);
    nameStack.push("fa-" + name);

    return nameStack;
  }

  /**
   * 
   * 
   * @param {faoption} option 
   */
  static GetStackedClassNames(option = {}){

    let nameStack = [];
    let innerStyle = [];

    let {color, size, fixWidth, rotate, flip, customRotate, 
      animate, stack, border, borderOption, pullLeft, pullRight, pullOption} = option;
    
    if(color) innerStyle.push("color: " + color + ";");
    if(size){
      if(_.isNumber(size)) nameStack.push("fa-" + String(size) + "x");
      else nameStack.push("fa-" + size);
    }
    if(fixWidth) nameStack.push("fa-fw");
    if(rotate) nameStack.push("fa-rotate-" + rotate);
    if(flip) nameStack.push("fa-flip-" + flip);
    if(customRotate) {
      nameStack.push("fa-rotate-by");
      innerStyle.push("--fa-rotate-angle: " + String(customRotate) + "deg;");
    }
    if(stack){
      nameStack.push("fa-stack-" + String(stack) + "x");
    }

    if(animate){
      let res = this.GetAnimatedStackedClassNames(animate);
      if(!_.isEmpty(res?.nameStack)) nameStack.push(...res.nameStack);
      if(!_.isEmpty(res?.innerStyle)) innerStyle.push(...res.innerStyle);
    }

    if(border) nameStack.push("fa-border");
    if(borderOption){
      let {color, padding, radius, style, width } = borderOption;
      if(color) innerStyle.push("--fa-border-color: " + color);
      if(padding) innerStyle.push("--fa-border-padding: " + padding);
      if(radius) innerStyle.push("--fa-border-radius: " + radius);
      if(style) innerStyle.push("--fa-border-style: " + style);
      if(width) innerStyle.push("--fa-border-width: " + width);
    }

    if(pullLeft) nameStack.push("fa-pull-left");
    if(pullRight) nameStack.push("fa-pull-right");
    if(pullOption){
      let {margin} = pullOption;
      if(margin) innerStyle.push("--fa-pull-margin: " + margin);
    }

    return {
      nameStack,
      innerStyle
    };
  }

  /**
   * 
   * @param {faanimateoption} animate 
   */
  static GetAnimatedStackedClassNames(animate){
    let nameStack = [];
    let innerStyle = []; 

    switch(animate.type){
      case "beat":
        nameStack.push("fa-beat");
        let {beatScale} = animate;
        if(beatScale) innerStyle.push("--fa-beat-scale: " + String(beatScale) + ";");
        break;
      case "fade":
        nameStack.push("fa-fade");
        let {fadeOpacity} = animate;
        if(fadeOpacity) innerStyle.push("--fa-fade-opacity: " + String(fadeOpacity) + ";");
        break;
      case "beat-fade":
        nameStack.push("fa-beat-fade");
        let {beatFadeOpacity, beatFadeScale} = animate;
        if(beatFadeOpacity) innerStyle.push("--fa-beat-fade-opacity: " + String(beatFadeOpacity) + ";");
        if(beatFadeScale) innerStyle.push("--fa-beat-fade-scale: " + String(beatFadeScale) + ";");
        break;
      case "bounce":
        nameStack.push("fa-bounce");
        let {bounceRebound, bounceHeight, bounceStartScaleX, bounceStartScaleY,
          bounceJumpScaleX, bounceJumpScaleY, bounceLandScaleX, bounceLandScaleY} = animate;
        if(bounceRebound) innerStyle.push("--fa-bounce-rebound: " + String(bounceRebound) + ";");
        if(bounceHeight) innerStyle.push("--fa-bounce-height: " + String(bounceHeight) + ";");
        if(bounceStartScaleX) innerStyle.push("--fa-bounce-start-scale-x: " + String(bounceStartScaleX) + ";");
        if(bounceStartScaleY) innerStyle.push("--fa-bounce-start-scale-y: " + String(bounceStartScaleY) + ";");
        if(bounceJumpScaleX) innerStyle.push("--fa-bounce-jump-scale-x: " + String(bounceJumpScaleX) + ";");
        if(bounceJumpScaleY) innerStyle.push("--fa-bounce-jump-scale-y: " + String(bounceJumpScaleY) + ";");
        if(bounceLandScaleX) innerStyle.push("--fa-bounce-land-scale-x: " + String(bounceLandScaleX) + ";");
        if(bounceLandScaleY) innerStyle.push("--fa-bounce-land-scale-y: " + String(bounceLandScaleY) + ";");
        
        break;
      case "flip":
        nameStack.push("fa-flip");
        let {flipX, flipY, flipZ, flipAngle} = animate;
        if(flipX) innerStyle.push("--fa-flip-x: " + String(flipX) + ";");
        if(flipY) innerStyle.push("--fa-flip-y: " + String(flipY) + ";");
        if(flipZ) innerStyle.push("--fa-flip-z: " + String(flipZ) + ";");
        if(flipAngle) innerStyle.push("--fa-flip-angle: " + String(flipAngle) + ";");
        
        break;
      case "shake":
        nameStack.push("fa-shake");
        break;
      case "spin":
        nameStack.push("fa-spin");
        break;
      case "spin-reverse":
        nameStack.push("fa-spin-reverse");
        break;
      case "spin-pulse":
        nameStack.push("fa-spin-pulse");
        break;
      default: break;
    }

    let {delay, direction, duration, iterationCount, timingFunction} = animate;
    if(delay) innerStyle.push("--fa-animation-delay: " + String(delay) + "s;");
    if(direction) innerStyle.push("--fa-animation-direction: " + direction + ";");
    if(duration) innerStyle.push("--fa-animation-duration: " + String(duration) + "s;");
    if(iterationCount) innerStyle.push("--fa-animation-iteration-count: " + String(iterationCount) + ";");
    if(timingFunction) innerStyle.push("--fa-animation-timing: " + timingFunction + ";");
        
    return {
      nameStack,
      innerStyle
    };
  }

  static GetWithStyle(name, style){
    return (
      <span style={style}>
        <i className={name}/>
      </span>
    );
  }

}

export default FontAwesomeX;